import { FC } from 'react';

import Stack from '@mui/material/Stack';

import WaveUIForm_V2 from '@/shared/components/forms/WaveUIForm_V2';
import FieldType from '@/shared/components/forms/WaveUIForm_V2/types/fieldType.enum';
import WaveUIAccordion from '@/shared/components/widgets/WaveUIAccordion';

import useTaxRecipientForm from './hooks/useTaxRecipientForm';

type TaxRecipientFormProps = {
  taxRecipientFormState: ReturnType<typeof useTaxRecipientForm>;
};

const TaxRecipientForm: FC<TaxRecipientFormProps> = ({
  taxRecipientFormState,
}) => {
  const {
    taxRecipientForm,
    taxRecipientFormOptional,
    setTaxRecipientForm,
    setTaxRecipientFormOptional,
  } = taxRecipientFormState;

  return (
    <Stack spacing={2}>
      <WaveUIForm_V2
        fields={[
          {
            field_type: FieldType.Select,
            field_props: {
              name: 'type',
              label: 'Type',
              value: taxRecipientForm.type,
              placeholder: 'Type ...',
              options: [
                {
                  label: 'Shipper',
                  value: 'shipper',
                },
                {
                  label: 'Receiver',
                  value: 'receiver',
                },
                {
                  label: 'Other',
                  value: 'other',
                },
              ],
            },
          },
          {
            field_type: FieldType.Select,
            field_props: {
              name: 'reason_for_export',
              label: 'Reason for Export',
              value: taxRecipientForm.reason_for_export,
              placeholder: 'Reason for Export ...',
              options: [
                {
                  label: 'Gift',
                  value: 'gift',
                },
                {
                  label: 'Repair Warranty',
                  value: 'repair-warranty',
                },
                {
                  label: 'Commercial Sample',
                  value: 'commercial-sample',
                },
                {
                  label: 'Return Shipment',
                  value: 'return-shipment',
                },
                {
                  label: 'Commercially Sold Goods',
                  value: 'commercially-sold-goods',
                },
                {
                  label: 'Other',
                  value: 'other',
                },
              ],
            },
          },
        ]}
        getFieldsValues={(value) => {
          setTaxRecipientForm((prev) => ({ ...prev, ...value }));
        }}
      />

      <WaveUIAccordion
        title='Optional Fields'
        elevation={0}
        // TODO: if not reciever set then show optional fields
        sx={{ mx: '-16px !important' }}
      >
        <WaveUIForm_V2
          fields={[
            {
              field_type: FieldType.Text,
              field_props: {
                name: 'shipper_tax_identifier',
                label: 'Shipper Tax Identifier',
                value: taxRecipientFormOptional.shipper_tax_identifier,
                placeholder: 'Shipper Tax Identifier ...',
              },
            },
            {
              field_type: FieldType.Text,
              field_props: {
                name: 'receiver_tax_identifier',
                label: 'Receiver Tax Identifier',
                value: taxRecipientFormOptional.receiver_tax_identifier,
                placeholder: 'Receiver Tax Identifier ...',
              },
            },
            {
              field_type: FieldType.Text,
              field_props: {
                name: 'third_party_tax_identifier',
                label: 'Third Party Tax Identifier',
                value: taxRecipientFormOptional.third_party_tax_identifier,
                placeholder: 'Third Party Tax Identifier ...',
              },
            },
            {
              field_type: FieldType.Text,
              field_props: {
                name: 'additional_remarks',
                label: 'Additional Remarks',
                value: taxRecipientFormOptional.additional_remarks,
                placeholder: 'Additional Remarks ...',
              },
            },
            {
              field_type: FieldType.Text,
              field_props: {
                name: 'comments',
                label: 'Comments',
                value: taxRecipientFormOptional.comments,
                placeholder: 'Comments ...',
              },
            },
          ]}
          getFieldsValues={(value) => {
            setTaxRecipientFormOptional((prev) => ({ ...prev, ...value }));
          }}
        />
      </WaveUIAccordion>
    </Stack>
  );
};

export default TaxRecipientForm;
